import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import _ from 'lodash'
import moment from 'moment'
import PropTypes from 'prop-types'
import config from '../../../config'
import InputMask from 'react-input-mask'
import { Button, Form, Modal, Popconfirm, Input, Radio, DatePicker } from 'antd'

// import * as revisionSelectors from '../../../selectors/revision'

import Attachments from './Attachments'
import StopCallsNotes from './StopCallsNotes'

const FormItem = Form.Item
const { TextArea } = Input
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const { API_BASE } = config

const propTypes = {
  selectedStopCall: PropTypes.object,
  isModalOpen: PropTypes.bool.isRequired,
  handleCancel: PropTypes.func.isRequired,
  createStopCall: PropTypes.func.isRequired,
  updateStopCall: PropTypes.func.isRequired,
  deleteStopCall: PropTypes.func.isRequired
}

class AddEditModal extends Component {
  state = {
    fileList: [],
    attachmentDetailsVisible: false,
    attachmentName: null
  }

  componentDidUpdate(prevProps) {
    // update the current version for printing
    // if (prevProps.loadingRevision !== this.props.loadingRevision) {
    //   const { revisions } = this.props
    //   if (revisions) {
    //     this.setState({
    //       currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber
    //     })
    //   }
    // }
  }

  handleCreateEdit = () => {
    const form = this.props.form
    const { createStopCall, updateStopCall, selectedStopCall } = this.props
    form.validateFields((err, values) => {
      if (err) {
        return
      }

      if (!selectedStopCall) {
        createStopCall(values)
      } else {
        updateStopCall(values)
      }

      form.resetFields()
    })
  }

  confirmDelete = () => {
    const { deleteStopCall, selectedStopCall } = this.props
    deleteStopCall(selectedStopCall.id)
  }

  onDescriptionChange = e => {
    this.setState({
      attachmentDescription: e.target.value
    })
  }

  handleEditAttachment = () => {
    const { selectedStopCall } = this.props
    this.props.updateAttachmentDescription({
      attachmentId: selectedStopCall.id,
      testingId: selectedStopCall.id,
      description: this.state.attachmentDescription
    })
    this.setState({
      attachmentDetailsVisible: false
    })
  }

  handleRevisionChange = revisionNumber => {
    const { getRevision, updateselectedStopCall } = this.props
    const revision = getRevision(revisionNumber + 1)
    updateselectedStopCall(revision)
  }

  render() {
    const { selectedStopCall, isModalOpen, handleCancel } = this.props

    const selectedStopCallId = _.get(selectedStopCall, 'id', null)

    const { getFieldDecorator } = this.props.form

    return (
      <Modal
        visible={isModalOpen}
        title="Stop Call"
        okText={selectedStopCall ? 'Save Changes' : 'Create'}
        onCancel={handleCancel}
        onOk={this.handleCreateEdit}
        width="70%"
        maskClosable={false}
      >
        <Form layout="vertical">
          {selectedStopCall && (
            <div className="row">
              <div className="col-md-11">
                <h2 className="marginBottom0">Stop Call #{selectedStopCall.id}</h2>
              </div>
              <div className="col-1 text-right">
                <a
                  href={`${API_BASE}/api/job/stop_calls/${selectedStopCall.id}/print/`}
                  target="_blank"
                >
                  <Button icon="printer" className="marginLeft5" />
                </a>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-6">
              <div className="row">
                <div className="col-md-6">
                  <FormItem label="Status">
                    {getFieldDecorator('status', {
                      rules: [
                        {
                          required: true,
                          message: 'Status cannot be blank.'
                        }
                      ],
                      initialValue: selectedStopCall ? selectedStopCall.status : 'open'
                    })(
                      <RadioGroup>
                        <RadioButton value="open">Open</RadioButton>
                        <RadioButton value="completed">Completed</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
                <div className="col-md-6">
                  <FormItem label="Billable">
                    {getFieldDecorator('billable', {
                      initialValue: selectedStopCall ? selectedStopCall.billable.toString() : ''
                    })(
                      <RadioGroup>
                        <RadioButton value="0">No</RadioButton>
                        <RadioButton value="1">Yes</RadioButton>
                      </RadioGroup>
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <FormItem label="Date">
                {getFieldDecorator('stop_call_date', {
                  rules: [
                    {
                      required: true,
                      message: 'Date cannot be blank.'
                    }
                  ],
                  initialValue: selectedStopCall ? moment(selectedStopCall.stop_call_date) : null
                })(<DatePicker format="MM/DD/YYYY" style={{ width: '100%' }} />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Elevators">
                {getFieldDecorator('elevators', {
                  initialValue: selectedStopCall ? selectedStopCall.elevators : ''
                })(<Input placeholder="Type Elevators..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Caller Name">
                {getFieldDecorator('caller_name', {
                  rules: [
                    {
                      required: true,
                      message: 'Caller Name cannot be blank.'
                    }
                  ],
                  initialValue: selectedStopCall ? selectedStopCall.caller_name : ''
                })(<Input placeholder="Type caller name..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Caller Number">
                {getFieldDecorator('caller_number', {
                  initialValue: selectedStopCall ? selectedStopCall.caller_number : ''
                })(
                  <InputMask
                    className="ant-input"
                    mask="(999) 999-9999 ext:9999"
                    maskChar="_"
                    placeholder="Type caller number..."
                  />
                )}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Ticket Number">
                {getFieldDecorator('ticket_number', {
                  initialValue: selectedStopCall ? selectedStopCall.ticket_number : ''
                })(<Input placeholder="Type ticket number..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Complaint">
                {getFieldDecorator('complaint', {
                  rules: [
                    {
                      required: true,
                      message: 'Note complaint cannot be blank.'
                    }
                  ],
                  initialValue: selectedStopCall ? selectedStopCall.complaint : ''
                })(<TextArea placeholder="Describe the complaint..." rows={4} />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <FormItem label="Mechanic">
                {getFieldDecorator('mechanic', {
                  initialValue: selectedStopCall ? selectedStopCall.mechanic : ''
                })(<Input placeholder="Type the mechanic..." />)}
              </FormItem>
            </div>
            <div className="col-md-6">
              <FormItem label="Supervisor">
                {getFieldDecorator('supervisor', {
                  initialValue: selectedStopCall ? selectedStopCall.supervisor : ''
                })(<Input placeholder="Type the supervisor..." />)}
              </FormItem>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FormItem label="Solution">
                {getFieldDecorator('solution', {
                  initialValue: selectedStopCall ? selectedStopCall.solution : ''
                })(<TextArea placeholder="Describe the solution..." rows={4} />)}
              </FormItem>
            </div>
          </div>
        </Form>
        {selectedStopCall && (
          <div>
            <StopCallsNotes stopCallId={selectedStopCallId} />
            <Attachments selectedStopCall={selectedStopCall} />
          </div>
        )}
        <Popconfirm
          title="Are you sure you want to delete this record?"
          onConfirm={this.confirmDelete}
          onCancel={this.cancelDelete}
          okText="Yes"
          cancelText="No"
        >
          {selectedStopCall && <Button type="danger" icon="delete" />}
        </Popconfirm>
      </Modal>
    )
  }
}

const mapStateToProps = (state, props) => ({})
const mapDispatchToProps = (dispatch, props) => ({})

AddEditModal.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(AddEditModal)))



// WEBPACK FOOTER //
// ./src/components/jobs/stop_call/AddEditModal.js